<template>
  <div class="payInit">
    <div ref="alipay"></div>
  </div>
</template>
<script>
import { assemblyParameters, payment4WapAlipay } from '@/api/payInit';
import { Dialog, Loading, Toast } from 'vant';
export default {
  components: {
    [Loading.name]: Loading,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      appId: 'wx6ad75686a3c8ec78',
      resData: '',
      aliData: '',
    };
  },
  created() {
    // 取得浏览器的userAgent字符串
    const userAgent = navigator.userAgent;
    // 判断微信浏览器
    if (userAgent.includes('MicroMessenger')) {
      this.wechatPayInit();
    } else if (userAgent.includes('AlipayClient')) {
      this.aliPayInit();
    } else {
      Toast('请使用微信或支付宝进行扫码支付');
    }
  },
  destoryed() {
    document.removeEventListener(
      'WeixinJSBridgeReady',
      this.onBridgeReady,
      false
    );
  },
  mounted() {},
  methods: {
    // 微信
    // 流程：扫码进入此页面，此时参数没有code,执行微信的跳转链接，微信生成code后再次重定向到此页面，进入有code的判断条件中......
    wechatPayInit() {
      const { code, id, type, payShare = 0, payableAmount } = this.$route.query;
      if (code) {
        let params = {
          code,
          paymentTypeEnum: type,
          payShare,
        };
        if (payableAmount) {
          params.payableAmount = payableAmount;
        }
        if (type == 'CREDIT_PREPAY') {
          // 提前还款
          params = { ...params, bizContent: id };
        } else {
          // 订单或是账单
          params = { ...params, bizId: id };
        }
        assemblyParameters(params).then((res) => {
          if (res.data) {
            this.resData = res.data;
            if (typeof WeixinJSBridge == 'undefined') {
              if (document.addEventListener) {
                document.addEventListener(
                  'WeixinJSBridgeReady',
                  this.onBridgeReady,
                  false
                );
              }
            } else {
              this.onBridgeReady();
            }
            // this.onBridgeReady(res.data)
          }
        });
      } else {
        // eslint-disable-next-line no-undef
        const url = encodeURIComponent(
          process.env.VUE_APP_P_URL +
            '?id=' +
            id +
            '&type=' +
            type +
            '&payShare=' +
            payShare +
            '&t=' +
            new Date().getTime() +
            (payableAmount ? '&payableAmount=' + payableAmount : '')
        );
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appId}&redirect_uri=${url}&response_type=code&scope=snsapi_base&state=0#wechat_redirect`;
      }
    },
    onBridgeReady() {
      const that = this;

      const { appId, timeStamp, nonceStr, packagePrepayId, paySign } =
        this.resData;
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: appId, // 公众号ID，由商户传入
          timeStamp: timeStamp, // 时间戳，自1970年以来的秒数
          nonceStr: nonceStr, // 随机串
          package: packagePrepayId,
          signType: 'RSA', // 微信签名方式：
          paySign: paySign,
        },
        function (res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            window.WeixinJSBridge.call('closeWindow');
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          } else {
            Dialog.confirm({
              message: '确定放弃支付吗？',
              theme: 'round-button',
              confirmButtonText: '继续支付',
              cancelButtonText: '关闭',
            })
              .then(() => {
                setTimeout(() => {
                  that.onBridgeReady();
                }, 300);
              })
              .catch(() => {
                window.WeixinJSBridge.call('closeWindow');
              });
          }
        }
      );
    },
    // 支付宝
    aliPayInit() {
      const { id, type, payShare = 0, payableAmount } = this.$route.query;
      const params = {
        bizContent: '',
        bizId: id,
        payShare,
        paymentTypeEnum: type,
        // returnSuccessUrl: window.location.origin + '/paySuccess'
        returnSuccessUrl: '',
      };
      if (payableAmount) {
        params.payableAmount = payableAmount;
      }
      payment4WapAlipay(params).then((res) => {
        if (res.data) {
          this.aliData = res.data;
          this.$refs.alipay.innerHTML = res.data;
          this.$refs.alipay.children[0].submit(); // 执行后会唤起支付宝
          // eslint-disable-next-line no-console
          console.log(res.data, this.$refs.alipay.children[0]);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.van-dialog {
  border-radius: 8px;
}
</style>
